import localStorage from 'store'

export default {
  user: localStorage.get('user') || {},
  users: [],
  agents: [],
  masteragentchilds: [],
  agentchilds: [],
  masteragentclients: [],
  agentclients: [],
  player : localStorage.get('player') || {},
  playerToken : localStorage.get('playerToken') || '',

  betrecords : [],
  betrecordbacarat : [],
  betrecordlonghu : [],
  betrecordsicbo : [],
  betrecordroulette : [],
  agentamountrecord : [],
  profitlossreport : [],
  curexchangereport :[],
  agentcreditreport : [],
  clientcreditreport : [],
  operatorlogreports : [],
  agentsubaccounts: [],
  claimrebatereports : [],
  tabs: [
    { name: "Index" }
  ],
  notifications: {
    promo: 0,
    message: 0,
    bank_deposit: 0,
    party: 0,
    withdraw: 0,
    affiliate_withdraw: 0,
    new_game: 0,
  },
  token: localStorage.get('token') || '',

  // Master data
  listbetlimit: [],

  // Unused yet
  tasks: [],
  vendors: [],
  withdrawals: [],
  withdrawal: {},
  deposits: [],
  deposit: {}
}
